import React from 'react';
import { SingleSpanTable } from '../SingleSpanTable';
export const DOBRequestDataTableV2 = ({ requestData }) => {
    return (React.createElement(SingleSpanTable, { items: [
            {
                label: 'First Name',
                value: requestData.firstName
            },
            {
                label: 'Last Name',
                value: requestData.lastName
            },
            {
                label: 'Date of Birth',
                value: requestData.dob
            },
            {
                label: 'Email',
                value: requestData.email
            },
            {
                label: 'Address Line 1',
                value: requestData.address.line1
            },
            {
                label: 'Address Line 2',
                value: requestData.address.line2
            },
            {
                label: 'City',
                value: requestData.address.city
            },
            {
                label: 'District',
                value: requestData.address.district
            },
            {
                label: 'Postal Code',
                value: requestData.address.postalCode
            },
            {
                label: 'Country',
                value: requestData.address.country
            }
        ], numColumns: 2 }));
};
